"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBtn = exports.Icon = exports.MessageWrapper = exports.Label = exports.Row = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Row = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${({ $isTheme }) => ($isTheme ? "48px" : "32px")};
  padding: ${({ $isTheme }) => ($isTheme ? "0 16px" : "0 8px")};

  &:hover {
    ${({ $isTheme }) => !$isTheme &&
    (0, styled_components_1.css) `
        background: ${colors_1.LIGHT_GREY};
      `}
  }

  & label,
  & span {
    ${({ $newProp }) => $newProp &&
    (0, styled_components_1.css) `
        animation: colorChange 1s;
      `}
  }

  @keyframes colorChange {
    0% {
      color: currentColor;
    }

    100% {
      color: ${colors_1.SWEGON_GREEN};
    }
  }
`;
exports.Label = styled_components_1.default.label `
  font-size: ${({ $isTheme }) => ($isTheme ? "16px" : "14px")};
  color: ${colors_1.GREY4};
  justify-self: flex-start;
  display: flex;
  align-items: center;

  label {
    font-size: 14px;
  }
`;
exports.MessageWrapper = styled_components_1.default.div ``;
exports.Icon = styled_components_1.default.label `
  display: flex;
  font-size: 14px;
  color: ${colors_1.GREY4};

  ${({ $enableTooltip }) => $enableTooltip &&
    (0, styled_components_1.css) `
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }

      visibility: visible;
    `};
`;
exports.IconBtn = styled_components_1.default.div `
  margin-left: 5px;
  cursor: pointer;
`;
//# sourceMappingURL=CalculationRowCompact.styles.js.map